import { useState, useEffect } from 'react';
import { FormGroup, Label, Input, Button } from 'reactstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import '../../helpers/datePickerConfig';
import { formatDate } from '../../helpers/dateUtils';
import Loader from '../../layouts/loader/Loader';
import funcionalidadesApiService from '../../services/http/funcionalidadesApiService';
import ModalClickable from '../../layouts/modals/ModalClickable';
import logger from '../../services/logger';

const PanelDeControl = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isSaved, setIsSaved] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const datos = await funcionalidadesApiService.cargarFuncionalidades({
          headquarter: 'CEDESCA',
        });
        setIsLoading(false);
        setData(datos);
      } catch (error) {
        setIsLoading(false);
        setData([]);
        logger.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, []);

  const saveData = async () => {
    try {
      // Formatear las fechas antes de enviarlas al backend
      const formattedData = data.map((item) => ({
        ...item,
        fechaInicio: item.fechaInicio ? formatDate(item.fechaInicio, 'yyyy-MM-dd') : null,
        fechaFin: item.fechaFin ? formatDate(item.fechaFin, 'yyyy-MM-dd') : null,
      }));

      // Enviar los datos formateados al backend
      await funcionalidadesApiService.guardarFuncionalidades({
        data: formattedData,
      });
      setIsSaved(true);
    } catch (error) {
      logger.error('Error saving data:', error);
    }
  };

  const isPasarelaStripe = (nombre) => /stripe/i.test(nombre || '');
  const isPasarelaRedsys = (nombre) => /redsys/i.test(nombre || '');

  const handleToggle = (index) => {
    const updatedData = [...data];
    const target = updatedData[index];
    const nuevoEstado = target.estado === 1 ? 0 : 1;
    target.estado = nuevoEstado;

    if (nuevoEstado === 1) {
      const targetIsStripe = isPasarelaStripe(target.nombre);
      const targetIsRedsys = isPasarelaRedsys(target.nombre);
      if (targetIsStripe || targetIsRedsys) {
        updatedData.forEach((it) => {
          if (it === target) return;
          if (targetIsStripe && isPasarelaRedsys(it.nombre)) it.estado = 0;
          else if (targetIsRedsys && isPasarelaStripe(it.nombre)) it.estado = 0;
        });
      }
    }
    setData(updatedData);
  };

  const handleFechaChange = (index, field, date) => {
    const updatedData = [...data];
    updatedData[index][field] = date;

    const fechaFinAsDate = updatedData[index].fechaFin
      ? new Date(updatedData[index].fechaFin)
      : null;
    if (
      field === 'fechaInicio' &&
      fechaFinAsDate &&
      date >= fechaFinAsDate
    ) {
      updatedData[index].fechaFin = new Date(date.getTime() + 24 * 60 * 60 * 1000);
    }
    setData(updatedData);
  };

  return (
    <div>
      {isSaved && <ModalClickable header="Cambios guardados" />}
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <h4>Funcionalidades</h4>
          {data.map((item, index) => (
            <FormGroup switch key={item.id}>
              <Label check>{item.nombre}</Label>
              <Input
                type="switch"
                checked={item.estado === 1}
                onChange={() => handleToggle(index)}
              />

              {/* Texto encima de los calendarios */}
              {item.fechaInicio && item.fechaFin && (
                <div>
                  <Label>Elegir la fecha de inicio y fin de matriculación</Label>
                  <div className="row mt-3">
                    <div className="col-6">
                      <Label>Fecha de inicio:</Label>
                      <DatePicker
                        selected={item.fechaInicio ? new Date(item.fechaInicio) : null}
                        onChange={(date) => handleFechaChange(index, 'fechaInicio', date)}
                        dateFormat="dd/MM/yyyy"
                        locale="es"
                        className="form-control"
                        wrapperClassName="w-100"
                      />
                    </div>
                    <div className="col-6">
                      <Label>Fecha de fin:</Label>
                      <DatePicker
                        selected={item.fechaFin ? new Date(item.fechaFin) : null}
                        onChange={(date) => handleFechaChange(index, 'fechaFin', date)}
                        dateFormat="dd/MM/yyyy"
                        locale="es"
                        minDate={item.fechaInicio ? new Date(item.fechaInicio) : null}
                        className="form-control"
                        wrapperClassName="w-100"
                      />
                    </div>
                  </div>
                </div>
              )}
            </FormGroup>
          ))}

          <div className="d-flex justify-content-end mt-3">
            <Button onClick={saveData}>Guardar cambios</Button>
          </div>
        </>
      )}
    </div>
  );
};

export default PanelDeControl;
